import { connect } from 'react-redux';

import { entityLoading, entityRequested } from '../selectors/entities';
import { tournamentsGroupedByPromotionLevelBySportIdsSortingByPrioritySelector } from '../selectors/gridPresentation';
import { SportsGrid } from './components/SportsGrid';

const createMapStateToProps = () => {
  return (state) => ({
    tournamentsBySportId:
      tournamentsGroupedByPromotionLevelBySportIdsSortingByPrioritySelector(state),
    liveEntityLoading: entityLoading(state),
    liveEntityRequested: entityRequested(state),
  });
};

export const AllSportsGrid = connect(createMapStateToProps)(SportsGrid);
